import { AppMessageKeys } from '../../shared/translations/messages.ts'

export function mainGreetingId(date = new Date()): AppMessageKeys {
  const hour = date.getHours()
  if (hour < 12) return 'main.greeting.morning'
  if (hour < 18) return 'main.greeting.day'
  return 'main.greeting.evening'
}
